export enum EStatuses {
  WorksInProgress = 0,
  Forbidden = 403,
  NotFound = 404,
  InternalServerError = 500,
}

export interface IStatus {
  status: EStatuses;
  additionalDescription?: string;
}

export interface IStatusChildrenProps {
  isSaas: boolean;
  additionalDescription?: string;
}
